<form [formGroup]="usuarioForm" (ngSubmit)="onSubmit()" class="p-fluid">
    <div class="p-formgrid p-grid">
        <h1 class="text-center font-medium fon">Registro de Empresa</h1>
        <!-- Email -->
        <div class="p-field p-col-12 p-md-6">
            <label for="email">Email*</label>
            <input id="email" type="email" pInputText formControlName="email"
                [ngClass]="{'ng-invalid ng-dirty': f['email'].invalid && (f['email'].dirty || f['email'].touched)}" />
            <small *ngIf="f['email'].invalid && (f['email'].dirty || f['email'].touched)" class="p-error">
                <span *ngIf="f['email'].errors?.['required']">Correo obligatorio.</span>
                <span *ngIf="f['email'].errors?.['email']">Email inválido.</span>
            </small>
        </div>

        <!-- Contraseña -->
        <div class="p-field p-col-12 p-md-6">
            <label for="contrasena">Contraseña*</label>
            <p-password inputId="contrasena" formControlName="contrasena" [feedback]="true" [toggleMask]="true"
                promptLabel="Introduce una contraseña segura" weakLabel="Débil" mediumLabel="Media" strongLabel="Fuerte"
                inputStyleClass="password-input" [style]="{'width':'100%'}"></p-password>
            <small *ngIf="f['contrasena'].invalid && (f['contrasena'].dirty || f['contrasena'].touched)"
                class="p-error">
                <span *ngIf="f['contrasena'].errors?.['required']">Contraseña obligatoria.</span>
                <span *ngIf="f['contrasena'].errors?.['minlength']">Mínimo 6 caracteres.</span>
            </small>
        </div>

        <!-- Nombre/Razón social -->
        <div class="p-field p-col-12 p-md-6">
            <label for="nombre">Nombre / Razón social*</label>
            <input id="nombre" type="text" pInputText formControlName="nombre"
                [ngClass]="{'ng-invalid ng-dirty': f['nombre'].invalid && (f['nombre'].dirty || f['nombre'].touched)}" />
            <small *ngIf="f['nombre'].invalid && (f['nombre'].dirty || f['nombre'].touched)" class="p-error">
                <span *ngIf="f['nombre'].errors?.['required']">Se requiere nombre.</span>
            </small>
        </div>

        <!-- RFC -->
        <div class="p-field p-col-12 p-md-6">
            <label for="rfc">RFC</label>
            <input id="rfc" type="text" pInputText formControlName="rfc"
                [ngClass]="{'ng-invalid ng-dirty': f['rfc'].invalid && (f['rfc'].dirty || f['rfc'].touched)}" />
            <small *ngIf="f['rfc'].invalid && (f['rfc'].dirty || f['rfc'].touched)" class="p-error">
                <span *ngIf="f['rfc'].errors?.['required']">Se requiere el RFC.</span>
                <span *ngIf="f['rfc'].errors?.['maxlength']">Máx. 13 caracteres.</span>
                <span *ngIf="f['rfc'].errors?.['pattern']">Formato RFC inválido.</span>
            </small>
        </div>

        <!-- Entidad Federativa -->
        <div class="p-field p-col-12 p-md-6">
            <label for="entidad_federativa">Entidad Federativa*</label>
            <input id="entidad_federativa" type="text" pInputText formControlName="entidad_federativa"
                [ngClass]="{'ng-invalid ng-dirty': f['entidad_federativa'].invalid && (f['entidad_federativa'].dirty || f['entidad_federativa'].touched)}" />
            <small
                *ngIf="f['entidad_federativa'].invalid && (f['entidad_federativa'].dirty || f['entidad_federativa'].touched)"
                class="p-error">
                <span *ngIf="f['entidad_federativa'].errors?.['required']">Se requiere entidad.</span>

            </small>
        </div>

        <!-- Código Postal -->
        <div class="p-field p-col-12 p-md-6">
            <label for="codigo_postal">Código Postal*</label>
            <input id="codigo_postal" type="text" pInputText formControlName="codigo_postal" />
            <small *ngIf="f['codigo_postal'].invalid && (f['codigo_postal'].dirty || f['codigo_postal'].touched)"
                class="p-error">
                <span *ngIf="f['codigo_postal'].errors?.['pattern']">Debe ser 5 dígitos.</span>
            </small>
        </div>

        <!-- Nombre de Contacto -->
        <div class="p-field p-col-12 p-md-6">
            <label for="nombre_contacto">Representador Legal*</label>
            <input id="nombre_contacto" type="text" pInputText formControlName="nombre_contacto"
                [ngClass]="{'ng-invalid ng-dirty': f['nombre_contacto'].invalid && (f['nombre_contacto'].dirty || f['nombre_contacto'].touched)}" />
            <small *ngIf="f['nombre_contacto'].invalid && (f['nombre_contacto'].dirty || f['nombre_contacto'].touched)"
                class="p-error">
                <span *ngIf="f['nombre_contacto'].errors?.['required']">Se requiere nombre de contacto.</span>

            </small>
        </div>

        <!-- Teléfono -->
        <div class="p-field p-col-12 p-md-6">
            <label for="telefono">Teléfono*</label>
            <input id="telefono" type="text" pInputText formControlName="telefono" />
            <small *ngIf="f['telefono'].invalid && (f['telefono'].dirty || f['telefono'].touched)" class="p-error">
                <span *ngIf="f['telefono'].errors?.['pattern']">Sólo números (10–13 dígitos).</span>
            </small>
        </div>

        <!-- Botón -->
        <div class="p-field p-col-12">
            <button type="submit" pButton label="Registrar" [disabled]="usuarioForm.invalid"></button>
        </div>
    </div>
</form>
<p-toast></p-toast>